<template>
  <div class="adv_detail" >
      <div @click="closeDetail" class="close"/>
      <div class="table">
      <el-table  :data="detail_list" border :row-class-name="advDetailRowInfo" :cell-class-name="advDetailCellInfo">
        <el-table-column fixed prop="name" label="Details">
        </el-table-column>
        <el-table-column prop="value" label="">
        </el-table-column>
      </el-table>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        detail_list:[],
      }
    },
    props:{
        adv_id:{
            type:Number,
            default(){return 0},
        }
    },
    watch:{
        adv_id: async function(adv_id) {
            
            if(adv_id == 0){
                return;
            }
            const detail_data = await this.$post('/advertiser/detail',{adv_id:adv_id});
            let api_url = '';
            const api_url_obj = JSON.parse(detail_data.api_url);
            for(const flag in api_url_obj){
                api_url += flag+" : "+api_url_obj[flag];
            }
            const result = [
                {
                    "name":"Basic Details",
                    "value":""
                },
                {
                    "name":"Adv. Name",
                    "value":detail_data.adv_name,
                },
                {
                    "name":"Adv. Type",
                    "value":detail_data.adv_type,
                },
                {
                    "name":"Account Level",
                    "value":"Level "+detail_data.account_level.toUpperCase(),
                },
                {
                    "name":"Status",
                    "value":detail_data.status.toUpperCase(),
                },
                {
                    "name":"Client Finance Email",
                    "value":detail_data.client_finance_email,
                },
                {
                    "name":"Client Portal Address",
                    "value":detail_data.client_dashboard_addr,
                },
                {
                    "name":"Insertion Order(IO)",
                    "value":detail_data.io_file==null?"Unsigned":"Signed",
                },
                {
                    "name":"Remark",
                    "value":detail_data.remark,
                },
                {
                    "name":"Tracking Info",
                    "value":"",
                },
                {
                    "name":"API Source",
                    "value":detail_data.is_api==1?"YES":"NO",
                },
                {
                    "name":"API Url",
                    "value":api_url,
                },
                {
                    "name":"Click Parameters",
                    "value":detail_data.click_parameters,
                },
                {
                    "name":"Tracking Link Domain",
                    "value":detail_data.tracking_domain,
                },
                {
                    "name":"Postback Url",
                    "value":detail_data.postback,
                },
                {
                    "name":"Redirect Model",
                    "value":detail_data.jump_way === 0? "302":"Double meta refresh",
                },
                {
                    "name":"Creator",
                    "value":detail_data.creator,
                },
                {
                    "name":"Create Time",
                    "value":detail_data.createdAt,
                },
                {
                    "name":"Modify Time",
                    "value":detail_data.updatedAt,
                }
            ];
            this.detail_list = result;
        }
    },
    methods: {
        advDetailRowInfo({row, rowIndex}) {
            if (rowIndex === 0 || rowIndex === 9) {
                return 'adv-detail-title-info';
            }
                return '';
        },
        advDetailCellInfo({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 1){
                if(row.value == 'PAUSED') {
                return "status-paused";
                }
                if(row.value == 'ACTIVE') {
                    return "status-active";
                }
                if(row.value == 'Unsigned') {
                    return "status-paused";
                }
                if(row.value == 'Signed') {
                    return "status-active";
                }
                if(row.value == 'NO') {
                    return "status-paused";
                }
                else if(row.value == 'YES') {
                    return "status-active";
                }
            }
        },
        closeDetail() {
            this.rootGetAdvDetail(0,'adv');
        }
    },
	inject: ['rootGetAdvDetail'],
  }
</script>

<style scoped>

.adv_detail{
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
}
.close{
    flex-grow:100;
    height: 100%;

}
.table{
    width:40%;
    height: 100%;
    overflow: scroll;
}

</style>